<div class="success-wrap">
    <div *ngIf="showSuccess">
        <mat-icon class="success-icon">check</mat-icon>{{text}}
    </div>

    <ng-container *ngIf="!showSuccess">
        <ng-content></ng-content>
    </ng-container>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/success.wrap/success.wrap.component.html